const baseUrl = "/v1/admin/activity-log";

export const apiUrls = {
  list: `${baseUrl}`,
  details: (id: number): string => `${baseUrl}/${id}/details`,
};
